import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      Es muy conocida la historia que narra los padecimientos de Cristóbal Colón y su tripulación cuando no hallaban
      tierra, y quizá algunos sabemos que fue Rodrigo de Triana quien, antes que nadie, gritó “¡Tierra!”. Sin embargo,
      pocos han reparado en otros personajes que le devolvieron la esperanza a Colón y a su tripulación.
    </p>
    <p className="content justified">
      En el cuento “Los animales que ayudaron al almirante”, Oswaldo Díaz Díaz una vez más da protagonismo a esos
      personajes que no hacen parte de los libros de historia, pero sin quienes los hechos del pasado habrían tenido
      otro curso.
    </p>
    <p className="content justified">
      En esta ocasión son los peces y las aves quienes, con su vuelo y su danza marina, muestran a Colón y a su feroz
      tripulación que se encuentran cerca a la tierra.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Un gajao y un rabo de junco son los primeros pájaros que avistan desde las carabelas, “dos aves humildes, que en
      tierra no les hubieran llamado la atención, pero que en medio del mar tenían un halagüeño significado porque,
      según creencia de los marineros, tales aves nunca se apartan más de veinticinco leguas de la ribera”. Ese
      avistamiento fue el 14 de septiembre de 1492.
    </p>
    <p className="content justified">
      Luego viene otra poderosa señal: un cangrejito de agua dulce que lucha para mantenerse vivo en un palo flotante.
      "Un simple cangrejo de agua dulce, pero que fue recogido y llevado al Almirante, quien lo admiró mucho y lo guardó
      con aprecio...".
    </p>
    <p className="content justified">
      De una manera cronológica, que dista de ser aburrida o esquemática, Oswaldo Díaz Díaz estudia con meticuloso
      detalle los diarios de abordo del navegante y cuenta sucintamente cómo día a día un nuevo animal se acerca a
      alguna de las embarcaciones.
    </p>
    <p className="content justified">
      Una de las características de este texto es que se mantiene a medio camino entre la realidad histórica y la libre
      interpretación del autor. Porque, aunque sabemos que Díaz Díaz como buen historiador busca las fuentes primarias,
      es decir, revisa el diario de Colón, también vemos cómo desde su imaginario recrea el espíritu y el ánimo del
      almirante y su tripulación.
    </p>
    <p className="content justified">
      Además, notamos cómo otra de las características de la obra de Don Os se evidencia en este relato: la maravilla
      por las cosas sencillas de la vida, que al final pueden darle un vuelco a la historia. Como ese humilde pajarito
      que hoy no significa nada, mañana es sinónimo de salvación, de vida, de libertad.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
